import { Button, Form, Modal, Stack } from "react-bootstrap"
import InputField from "../common/InputField"
import { useState } from "react"
import { Loader } from "../common/Loader"
import { FiEye, FiEyeOff } from "react-icons/fi"
import { UploadImage } from "../common/UploadImage"
import { BiImageAdd } from "react-icons/bi"
import { addDriver } from "../../services/Networkcall"
import { errorAlert, successAlert } from "../common/Alert"

export const AddDriver = ({ show, closeModal, setRefetch}) => {
    const [fdata, setFdata] = useState({ driverName: "", driverEmail: "", password: "", phoneNumber: "", image: null });
    const [error, setError] = useState({ driverName: "", driverEmail: "", password: "", phoneNumber: "", image: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const togglePassword = () => { setShowPassword(!showPassword) }

    const inputHandler = (e) => {
        const { name, value } = e.target;
        setFdata((pre) => ({ ...pre, [name]: value }));
        setError((pre) => ({ ...pre, [name]: "" }));
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        let isValid = true;
        const newError = { driverName: "", driverEmail: "", password: "" };

        if (!fdata.driverName || !fdata.driverName.trim()) { isValid = false; newError.driverName = "Driver name is required"; }
        else if (fdata.driverName.trim().length < 2) { isValid = false; newError.driverName = "Name must be at least 2 characters"; }

        if (!fdata.driverEmail) { isValid = false; newError.driverEmail = "Email is required"; }

        if (!fdata.password || !fdata.password.trim()) { isValid = false; newError.password = "Password is required"; }

        if (!fdata.phoneNumber || !fdata.password.trim()) { isValid = false; newError.phoneNumber = "Mobile number is required"; }
        else if (!/^[0-9]+$/.test(fdata.phoneNumber)) { isValid = false; newError.phoneNumber = "Phone number must contain only numbers"; }

        setError(newError);
        if (!isValid) return;

        if (isValid) {
            const formData = new FormData();
            formData.append("userName", fdata.driverName);
            formData.append("email", fdata.driverEmail);
            formData.append("phoneNumber", fdata.phoneNumber);
            formData.append("password", fdata.password);
            if (fdata?.image) {
                formData.append("profileImage", fdata?.image);
            }

            try {
                setLoading(true);
                const res = await addDriver(formData);
                if (res?.success) {
                    successAlert({ message: res?.message });
                    closeModal();
                    setRefetch(true);
                }
                else {
                    errorAlert({ message: res?.message });
                }
            } catch (err) {
                errorAlert({ message: err?.response?.data?.message || err?.message || "Something went wrong." });
            }
            finally {
                setLoading(false);
            }
        }
    }




    return (
        <>
            <Loader show={loading} />
            <Modal show={show} onHide={closeModal} centered backdrop={'static'}>
                <Modal.Header closeButton><p className="w-100 text-center mb-0 fw-bold">Add Driver</p></Modal.Header>
                <Modal.Body>
                    <Form onSubmit={submitHandler} autoComplete="off">
                        <Stack direction="vertical" gap={3} >

                            <UploadImage
                                label=" "
                                name="image"
                                value={fdata.image}
                                onChange={inputHandler}
                                icon={<BiImageAdd color="#2563eb" size={30} />}
                                error={error.image}
                            />
                            <InputField
                                label={'Name'}
                                type={'text'}
                                value={fdata.driverName}
                                onChange={inputHandler}
                                name={'driverName'}
                                placeholder="Enter driver name"
                                autoComplete={"default"}
                                error={error.name}
                            />

                            <InputField
                                label={'Email'}
                                type="email"
                                name={'driverEmail'}
                                placeholder="Enter email"
                                value={fdata.driverEmail}
                                autoComplete="new-email"
                                required={true}
                                onChange={inputHandler}
                                error={error.email}
                            />

                            <InputField
                                type={"text"}
                                name={"phoneNumber"}
                                label="Mobile No"
                                placeholder="Enter Mobile No"
                                autoComplete={"default"}
                                onChange={inputHandler}
                                maxLength={15}
                                error={error.phoneNumber}
                                value={fdata.phoneNumber}
                            />

                            <InputField
                                label={'Password'}
                                type={showPassword ? "text" : "password"}
                                autoComplete={"new-password"}
                                name={'password'}
                                placeholder="Enter password"
                                className={'rounded '}
                                value={fdata.password}
                                onChange={inputHandler}
                                error={error.password}
                                endIcon={showPassword ? <FiEyeOff onClick={togglePassword} /> : <FiEye onClick={togglePassword} />}
                            />

                            <Button
                                className="w-100 rounded login-btn "
                                variant="primary"
                                type="submit"
                            >Submit
                            </Button>

                        </Stack>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}